import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const AccountForm = styled.form`
  display: flex;
  flex-direction: column;
  padding: 0 34px;
  font-size: var(--font-mds);
`;

export const TypeWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 28px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  div {
    display: flex;
    justify-content: space-between;
    height: 30px;
  }
`;

export const Label = styled.label`
  margin-bottom: 15px;
  font-weight: var(--font--bold);
  color: var(--sub-font-color);
  font-size: 12px;
`;

export const Description = styled.p`
  font-size: var(--font-sm);
  color: var(--sub-font-color);
  text-align: center;
  margin-bottom: 30px;
`;

export const ButtonImgStyle = styled.button`
  display: flex;
  justify-content: center;
  margin: 16px 0 8px;

  &:disabled {
    cursor: default;
  }
`;

export const ErrorMessage = styled.div`
  align-self: stretch;
  color: var(--error-color);
  font-size: var(--font-sm);
`;

export const ValidMessage = styled.div`
  align-self: stretch;
  color: var(--main-color);
  font-size: var(--font-sm);
`;

export const MoveSignup = styled(Link)`
  display: block;
  color: var(--sub-font-color);
  font-size: var(--font-sm);
  text-align: center;
`;
